import { eik } from "@borealis/image";
import { i18n } from "@lingui/core";
import finnImageUrl from "../../assets/zero-hits-finn.svg";
import toriImageUrl from "../../assets/zero-hits-tori.svg";
import blocketImageUrl from "../../assets/zero-hits-blocket.svg";
import dbaImageUrl from "../../assets/zero-hits-dba.svg";

type ZeroResultsProps = {
	className?: string;
	brand: string;
};

const brandImages: Record<string, string> = {
	FINN: eik(finnImageUrl),
	TORI: eik(toriImageUrl),
	BLOCKET: eik(blocketImageUrl),
	DBA: eik(dbaImageUrl),
};

export function ZeroResults(props: ZeroResultsProps) {
	const { className = "", brand = "tori" } = props;
	const src = brandImages[brand.toUpperCase()] || brandImages.TORI;

	return (
		<div className={`${className} flex flex-col items-center justify-center w-full`}>
			<div className="flex flex-col items-center md:w-1/2 sm:w-full justify-center">
				<img
					className="p-16"
					src={src}
					alt={i18n.t({
						id: "explore.results.zero-results.alt-text",
						message: "No results found",
					})}
				/>
				<h2 className="t2 text-center mb-8">
					{i18n.t({
						id: "explore.results.zero-results.heading",
						message: "No results found",
					})}
				</h2>

				<p className="text-body text-center mb-24">
					{i18n.t({
						id: "explore.results.zero-results.message",
						message: "Try to rephrase your search or adjust your filters to find what you're looking for.",
					})}
				</p>
			</div>
		</div>
	);
}
